import React from 'react';
import { AgFinancingCollateralAnalysisStatus, Collateral, Credit } from '@indigo-ag/schema';
import { Tag, TagProps } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { text } from 'shared';

const collateralStatusLabelMap: Record<Collateral['status'], string> = {
  [AgFinancingCollateralAnalysisStatus.STARTED]: i18next.t('in_process'),
  [AgFinancingCollateralAnalysisStatus.COMPLETED]: i18next.t('completed'),
  [AgFinancingCollateralAnalysisStatus.ON_HOLD]: i18next.t('onHold'),
  // * deprecated
  [AgFinancingCollateralAnalysisStatus.APPROVED]: i18next.t('approved'),
  [AgFinancingCollateralAnalysisStatus.DENIED]: i18next.t('denied'),
  [AgFinancingCollateralAnalysisStatus.WAITING_CREDIT_MANAGER_DECISION]: i18next.t('sentToCommittee')
};

const collateralStatusVariantMap: Record<Credit['status'], TagProps['variant']> = {
  [AgFinancingCollateralAnalysisStatus.STARTED]: 'info',
  [AgFinancingCollateralAnalysisStatus.COMPLETED]: 'success',
  [AgFinancingCollateralAnalysisStatus.ON_HOLD]: 'warning',
  // * deprecated
  [AgFinancingCollateralAnalysisStatus.APPROVED]: 'success',
  [AgFinancingCollateralAnalysisStatus.DENIED]: 'error',
  [AgFinancingCollateralAnalysisStatus.WAITING_CREDIT_MANAGER_DECISION]: 'warning'
};

interface CollateralAnalysisStatusTagProps {
  status: Collateral['status'];
}

export const CollateralAnalysisStatusTag: React.FunctionComponent<CollateralAnalysisStatusTagProps> = ({ status }) => {
  return (
    <Tag label={text.toTitleCase(collateralStatusLabelMap[status])} variant={collateralStatusVariantMap[status]} />
  );
};
